export default __webpack_public_path__ + "static/media/train2.e57830fe.png";